/*
 * @Description: 心智占有率 - 图表
 * @Author: yy
 * @Date: 2019-05-31 14:47:31
 * @LastEditors: yy
 * @LastEditTime: 2020-12-09 10:59:12
 */


import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './Mind.css';
// @ts-ignore
import ReactEcharts from 'echarts-for-react'

const calcPercent = (num, count) => (Math.round(num / count * 10000) / 100).toFixed(2);


class Mind extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      count: 0,
      selected: {}
    }
    this.getOption = this.getOption.bind(this)
  }

  componentDidMount () {
    const {json: list= []} = this.props
    this.setState({
      count: list.map(item => Math.abs(item.value)).reduce((prev, next) => prev + next)
    })
  }

  componentWillReceiveProps() {
    const {json: list=[]} = this.props
    this.setState({
      count: list.map(item => Math.abs(item.value)).reduce((prev, next) => prev + next)
    })
  }

  reloadCount = (event) => {
    const {json: list=[]} = this.props
    const {selected} = event

    this.setState({
      selected,
      count: list.filter(item => selected[item.name]).map(item => Math.abs(item.value)).reduce((prev, next) => prev + next)
    })
  }

  getOption = () => {
    const {selected, count} = this.state
    const itemStyle = {
      normal: {
        opacity: 0.7,
        borderWidth: 1,
        borderColor: '#000'
      }
    };

    const { tableData, battleMind = [], json } = this.props
    let qopData = json

    let mmData = []
    let legendData = []

    function makeData(qopData) {
      for (var i = 0; i < qopData.length; i++) {
        mmData.push({
          value: qopData[i].value,
          name: qopData[i].name,
          ratio: qopData[i].industry_mind || battleMind[i],
          itemStyle: {
            normal: {
              color: qopData[i].grayColor ? '#44548f' : '#ffd70d'
            }
          }
        })
        const name = qopData[i].name
        legendData.push(name)
      }
      return { mmData: mmData, legendData: legendData }
    }

    makeData(qopData)

    let aaa = this.props.items
    let legendTxt = aaa.map(i => i.name).join(' vs ')
    const propsIndustry = aaa.length > 1 ? '- 品牌对比' : this.props.industry ? '- ' + this.props.industry : '- ' + this.props.geo

    // countAll = this.state.count
    
    let option = {
      title: {
        text: `心智占有率 ${propsIndustry} - ${legendTxt}`,
        subtext: '数据来源：数字品牌榜',
        x: '20'
      },
      color: ['#ffd70d'],
      tooltip: {
        trigger: 'item',
        position: [
          '50%', '50%'
        ],
        formatter: function (params) {

          return `<div style="
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            text-align: center;
          ">
            ${calcPercent(params.value, count)}%<br/>${params.name}
            </div>`
          },
          // ${params.data.ratio}<br/>${params.name}
        backgroundColor: 'rgba(0,0,0,0)',
        padding: 0,
        textStyle: {
          color: '#eead81',
          fontWeight: 400,
          fontSize: 22,
          width: 160,
          height: 160
        },
        extraCssText: [
          'width: 160px;',
          'height: 160px;',
          'margin: -80px 0 0 -80px;'
        ].join('')
      },
      graphic: [{
        type: 'rect',
        z: 80,
        left: '20',
        top: '60',
        shape: {
          width: 230,
          height: 44
        },
        style: {
          fill: '#ffd70d',
          stroke: '#999'
        }
      }, {
        type: 'text',
        left: '20',
        top: 65,
        z: 100,
        style: {
          text: ' ● 阴影区颜色为黄色，表明好感度为正值；',
          // fill:'#ffd70d',
          stroke: '#ffd70d',
          font: '12px "STHeiti", sans-serif'
        }
      }, {
        type: 'text',
        left: '30',
        top: 85,
        z: 100,
        style: {
          text: ' 若为蓝色，表明好感度为负值。',
          // fill:'#ffd70d',
          stroke: '#44548f',
          font: '12px "STHeiti", sans-serif'
        }
      }],
      legend: {
        type: 'scroll',
        orient: 'vertical',
        padding: 20,
        top: '20',
        right: '10',
        bottom: '20',
        y: 'bottom',
        selected,
        data: legendData,
        inactiveColor: '#ccc'
      },
      toolbox: {
        show: true,
        feature: {
          dataView: {
            show: true,
            readOnly: true,
            buttonColor: '#ffd70d',
            title: '点此可查看数据视图',
            // optionToContent:this.renderTable(),
            optionToContent: function (opt) {
              let box = `<div style="overflow:auto;height:500px;">
              <table style="width:100%;text-align:center;color:#000;font-size:14px">
                <thead style="background-color:#f6f6f6;">
                  <tr style="height:35px;font-weight:bold">
                    <td>品牌</td>
                    <td>心智占有率</td>
                  </tr>
                </thead>
                <tbody>`

              const json = tableData
              for (let i = 0; i < json.length; i++) {
                box += `<tr style="height:35px;">
                    <td>${json[i].name}</td>
                    <td>${battleMind ? battleMind[i] : json[i].industry_mind || json[i].region_mind}</td>
                  </tr>`
              }

              box += `</tbody>
                  </table>
                </div>`
              return box
            },
          },
          restore: {},
          saveAsImage: {},
        },
        right: 20
      },
      calculable: true,
      series: [
        {
          name: '心智占有率',
          type: 'pie',
          radius: [
            '30%', '80%'
          ],
          center: [
            '50%', '50%'
          ],
          startAngle: 90,
          roseType: 'area',
          avoidLabelOverlap: true,
          label: {
            normal: {
              // formatter: '{b|{b}}\n{hr|}\n{a|{a}：}{per|{d}%}\n{hr|}\n {a|DB值：}{per|{c}}',
              // formatter: `{b|{b}} {per|{d}%}`,
              formatter (params) {
                
                // console.log(params,data)
                // return `{b|${params.name}}${params.color=='#ccc'?'-':''}{per|{d}}%}`
                // return `{b|${params.name}}{per|${params.data.ratio}}`
                
                return `{b|${params.name}}{per|${calcPercent(params.value, count)}%}`
              },
              backgroundColor: '#f2f2f2',
              borderColor: '#aaa',
              // borderWidth: 1,
              borderRadius: 4,
              padding: [0, 0],
              // shadowBlur:3, shadowOffsetX: 2, shadowOffsetY: 2, shadowColor: '#999',
              // padding: [0, 7],
              rich: {
                a: {
                  color: '#999',
                  lineHeight: 22,
                  align: 'center'
                },
                // abg: {     backgroundColor: '#333',     width: '100%',     align: 'right',
                //  height: 22,     borderRadius: [4, 4, 0, 0] },
                hr: {
                  borderColor: '#aaa',
                  width: '100%',
                  borderWidth: 0.5,
                  height: 0
                },
                b: {
                  fontSize: 14,
                  lineHeight: 25,
                  color: '#333',
                  align: 'center'
                },
                per: {
                  color: '#eee',
                  backgroundColor: '#334455',
                  align: 'center',
                  padding: [
                    2, 4
                  ],
                  borderRadius: 2,
                  fontSize: 14,
                }
              }
            },
            emphasis: {
              show: true
            }
          },
          lableLine: {
            normal: {
              show: true
            },
            emphasis: {
              show: true
            }
          },
          // data:mmData.sort(function(a,b){return b.value-a.value}),
          data: mmData.sort((a, b) => b.value - a.value),
          itemStyle: itemStyle
        }
      ]
    }
    return option
  }

  render() {
    const {count} = this.state
    const that = this
    return (<ReactEcharts

      option={this.getOption()}
      style={{
        height: '550px',
        width: '100%',

        borderRadius: '4px'
      }}
      className={s.charts}
      notMerge={true}
      lazyUpdate={true}
      theme={"theme_name"}
      onEvents={{
        legendselectchanged: this.reloadCount 
      }}
      // onChartReady={this.onChartReadyCallback} 
      />
    )
  }
}

export default withStyles(s)(Mind);



// WEBPACK FOOTER //
// src/components/Mind/Mind.js